import * as React from 'react';

const { useState } = React;

interface IAccordionProps {
  title: string;
  content: React.ReactChild;
  hasSubquestions?: boolean;
  isSub?: boolean;
}

export const Accordion: React.FC<IAccordionProps> = ({
  title,
  content,
  hasSubquestions,
  isSub,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleOpen = () => setIsOpen(!isOpen);

  return (
    <div className={`${!isSub ? 'border-b border-gray-darker' : ''}`}>
      <h3>
        <button
          className={`block w-full text-left py-3 px-4 focus:outline-none hover:bg-grey ${
            isOpen && !hasSubquestions
              ? 'bg-grey border-b border-grey-dark'
              : ''
          }`}
          onClick={toggleOpen}
        >
          {isSub ? <span className="opacity-50">&mdash;&nbsp;</span> : ''}
          {title}
        </button>
      </h3>
      {isOpen && (
        <div
          className={`accordion-content ${
            !hasSubquestions ? 'px-8 py-6 bg-grey' : ''
          }`}
        >
          {content}
        </div>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/Tutorial/components/Accordion.tsx